// extracted by mini-css-extract-plugin
module.exports = {"chip":"FilterChip_chip__4xKnm","active":"FilterChip_active__3AGbC"};